export default __webpack_public_path__ + "static/media/roulette-bg-tablet.e6db4cbb.png";